/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online Roman numeral converter. Convert numbers (1–3999) to Roman numerals and decode Roman numerals back to numbers. Works in your browser.`)
};

const es_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor gratuito de numerales romanos en línea. Convierte números (1–3999) a numerales romanos y decodifica numerales romanos a números. Funciona en tu navegador.`)
};

const de_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Umrechner für römische Zahlen. Wandeln Sie Zahlen (1–3999) in römische Zahlen um und dekodieren Sie römische Zahlen zurück in Zahlen. Funktioniert direkt in Ihrem Browser.`)
};

const nl_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online converter voor Romeinse getallen. Converteer getallen (1–3999) naar Romeinse getallen en omgekeerd. Werkt in uw browser.`)
};

const fr_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit de chiffres romains en ligne. Convertissez les nombres (1–3999) en chiffres romains et décodez les chiffres romains en nombres. Fonctionne dans votre navigateur.`)
};

const it_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore online gratuito di numerali romani. Converti i numeri (1–3999) in numerali romani e decodifica i numerali romani in numeri. Funziona nel tuo browser.`)
};

const pt_br2_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito online de numerais romanos. Converta números (1–3999) em numerais romanos e decodifique numerais romanos em números. Funciona no seu navegador.`)
};

const pt_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor online gratuito de numerais romanos. Converta números (1–3999) em numerais romanos e descodifique numerais romanos de volta para números. Funciona no seu navegador.`)
};

const ja_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンラインローマ数字コンバーター。数字(1〜3999)をローマ数字に変換し、ローマ数字を数字にデコードします。ブラウザで動作します。`)
};

const zh_rn_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线罗马数字转换器。将数字（1–3999）转换为罗马数字，并将罗马数字解码回数字。可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_meta_description", locale)
	if (locale === "en") return en_rn_meta_description(inputs)
	if (locale === "es") return es_rn_meta_description(inputs)
	if (locale === "de") return de_rn_meta_description(inputs)
	if (locale === "nl") return nl_rn_meta_description(inputs)
	if (locale === "fr") return fr_rn_meta_description(inputs)
	if (locale === "it") return it_rn_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_rn_meta_description(inputs)
	if (locale === "pt") return pt_rn_meta_description(inputs)
	if (locale === "ja") return ja_rn_meta_description(inputs)
	return zh_rn_meta_description(inputs)
};